<template>
  <header
    class="section-header-pos"
    :class="{ backgroundImage: isNotBackgroundImage }"
  >
    <div
      v-if="isShowHeader"
      class="section-header-pos__logo"
    >
      <img src="@/assets/images/header/logo.png"/>
    </div>
  </header>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {
    isShowHeader () {
      const urlNotShowHeader = [
        'Login',
        'TransactionSuccess',
        'TransactionOverview',
        'TransactionResult',
        'Lotto',
        'QrCodeInput',
        'ScanningQRCode',
        'TicketInput'
      ]
      return !urlNotShowHeader.includes(this.$route.name)
    },
    isNotBackgroundImage () {
      const urlNotShowHeader = [
        'TransactionOverview',
        'TransactionResult',
        'Lotto',
      ]
      return !urlNotShowHeader.includes(this.$route.name)
    }
  }
}
</script>
